import { render } from "./FooterWeb.vue?vue&type=template&id=b744cfee"
import script from "./FooterWeb.vue?vue&type=script&lang=js"
export * from "./FooterWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__